import { DailymotionPlatform } from '@app/modules/social-export/domain/platforms';
import { PlatformMultiConnect } from '../../../screens/manage/connect/PlatformMultiConnect';
import { dailymotionConnectAlternatives } from './dailymotion-connect-alternatives';

/**
 * Dailymotion multi-method connect: opens alternatives dialog (OAuth or API key).
 */
export function DailymotionConnect() {
  return (
    <PlatformMultiConnect
      platform={DailymotionPlatform}
      alternatives={dailymotionConnectAlternatives}
    />
  );
}
